var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mode === 'preview')?_c('div',{staticClass:"glb-container"},[_c('p',{staticClass:"glb-text-print"},[_vm._v("3D model screenshot could not be created")])]):(_vm.glbModelController.file)?_c('GlbModelViewer',{attrs:{"canEdit":false}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }